import { useEffect } from 'react';
import PropTypes from 'prop-types';

/**
 * Transient notification, replacing MUI Joy's Snackbar.
 *
 * `role="status"` with `aria-live="polite"` so a screen reader announces the
 * message without interrupting: these are confirmations and errors, not
 * alarms.
 */

const TONES = {
  success: 'border-green-300 bg-green-50 text-green-800',
  danger: 'border-red-300 bg-red-50 text-red-800',
  neutral: 'border-gray-300 bg-white text-gray-800',
};

export default function Snackbar({ open, message, color = 'neutral', onClose, autoHideDuration = 6000 }) {
  useEffect(() => {
    if (!open) return undefined;
    const timer = window.setTimeout(onClose, autoHideDuration);
    return () => window.clearTimeout(timer);
  }, [open, message, onClose, autoHideDuration]);

  if (!open || !message) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className={`fixed bottom-4 left-1/2 z-[1500] flex max-w-[90vw] -translate-x-1/2 items-center gap-3 rounded-md border px-4 py-2 text-sm shadow-lg ${TONES[color] || TONES.neutral}`}
    >
      <span>{message}</span>
      <button
        type="button"
        onClick={onClose}
        aria-label="Fermer"
        className="shrink-0 opacity-60 hover:opacity-100"
      >
        &times;
      </button>
    </div>
  );
}

Snackbar.propTypes = {
  open: PropTypes.bool,
  message: PropTypes.string,
  color: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  autoHideDuration: PropTypes.number,
};
